// extracted by mini-css-extract-plugin
export default {"root":"EAsB6j","loading":"tjP5fy","fullWidth":"pMkHN2","primary":"HsSQ3e","mobile":"ZjXyK0","basic":"WNJnpY","outlined":"n6Cq3l","filled":"fATuTh"};